export const Roles = {
  Landlord: "Landlord",
  Tenant: "Tenant",
  TradesPerson: "Tradesperson",
  Liaison: "Liaison",
  PropertyOwner: "PropertyOwner"
};
export const TenancyStatus = {
  Invited: "invited",
  Assigned: "assigned"
};
export const commentRoles = {
  Landlord: "Landlord",
  Tenant: "Tenant",
  Tradesperson: "Tradesperson",
  Liaison: "Property Liaison"
};
export const TradespersonTypes = Object.freeze({
  Landlord: "Landlord",
  PropertyOwner: "Property Owner",
  Liaison: "Liaison",
  Tradesperson: "Tradesperson"
});
// What kind of job a ticket is (Ticket.jobType), and the My Jobs "Job Type"
// filter - `All` is a filter value only. Mirrors enums.TicketJobType in fixify-server.
export const TicketJobType = Object.freeze({
  All: "all",
  Repair: "repair",
  Compliance: "compliance"
});
export const FilterTicketStatus = {
  New: "New",
  In_Progress: "In Progress",
  Closed: "Closed"
};
export const SnackbarSeverity = {
  warning: "warning",
  info: "info",
  success: "success",
  dange: "danger"
};

export const Store = {
  isLoggedIn: "isLoggedIn",
  trade: "trade",
  role: "role",
  displayRole: "displayRole",
  userId: "userId",
  token: "token",
  /** Scoped signup-only token (Landlord/TradesPerson mid-signup) — never a real session; only /update/:id accepts it. */
  profileCompletionToken: "profileCompletionToken",
  isProfileComplete: "isProfileComplete",
  email: "email",
  isEmailVerified: "isEmailVerified",
  businessName: "businessName",
  createdAt: "createdAt",
  updatedAt: "updatedAt",
  contact: "contact",
  profileImage: "profileImage",
  liaisonFirstLogin: "liaisonFirstLogin",
  landlordBusinessName: "landlordBusinessName",
  landlordDisplayRole: "landlordDisplayRole",
  expireSoon: "expireSoon",
  landlordLogoImage: "landlordLogoImage",
  firstName: "firstName",
  lastName: "lastName",
  /** Last FCM registration token stored for unregister on logout */
  fcmPushToken: "fcmPushToken",
  /** Stable id per browser/device for token rotation */
  fcmDeviceId: "fcmDeviceId",
  /** userId last successfully registered with current fcmPushToken */
  fcmLastRegisteredUserId: "fcmLastRegisteredUserId",
  /** Unix ms when push token was last POSTed successfully (heartbeat / stale healing) */
  fcmLastRegisteredAt: "fcmLastRegisteredAt",
  /** sessionStorage: signup | login — consumed on dashboard to auto-open onboarding */
  onboardingPendingTrigger: "onboardingPendingTrigger"
};

export const IntialUserState = {
  userData: {
    contact: "",
    email: "",
    firstName: "",
    jwtToken: "",
    lastName: "",
    role: "",
    isLoggedIn: false
  },
  signupPayload: {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    mobile: "",
    businessName: "",
    postCode: "",
    address: ""
  }
};

export const TicketStatus = Object.freeze({
  New: "New",
  Open: "Open",
  OpenAssigned: "OpenAssigned",
  Closed: "Closed",
  Reopen: "Reopen"
});

export const MyJobStatusFilter = Object.freeze({
  New: "New",
  In_Progress: "In Progress",
  Closed: "Closed (last 60 days)",
  Closed_Archived: "All (include archived)"
});

// My Jobs closed-jobs filter (landlord side), on closed date, counting back
// from today. Mirrors enums.MyJobsClosedPeriod in fixify-server.
export const MyJobsClosedPeriod = Object.freeze({
  Last_60_Days: "60d",
  Last_12_Months: "12m",
  Last_24_Months: "24m"
});

export const TicketSeverity = {
  Normal: "Normal",
  // Emergency: "Emergency",
  Urgent: "Urgent"
};

export const PropertyExtras = [
  {
    internet: "High Speed Internet"
  },
  {
    utility: "Separate Utility"
  },
  {
    parking: "Off Road Parking"
  },
  {
    oneMinWalk: "1 Minute Walk to Campus"
  },
  {
    twoMinWalk: "2 Minute Walk to Campus"
  },
  {
    fiveMinWalk: "5 Minute Walk to Campus"
  },
  {
    livingRoom: "Separate Living Room"
  },
  {
    garden: "Garden Maintenance"
  },
  {
    bicycle: "Bicycle Shed"
  },
  {
    livingArea: "Open-plan Living Area"
  },
  {
    refurbished: "Newly Refurbished"
  }
];

export const ActivityTimeLine = Object.freeze({
  Today: "Today",
  Yesterday: "Yesterday",
  This_Week: "This Week",
  Last_Week: "Last Week"
});

export const ActivityTimeLineSortOrder = Object.freeze({
  Today: 1,
  Yesterday: 2,
  "This Week": 3,
  "Last Week": 4
});

export const ageProfileChartXLabels = Object.freeze({
  "< 3 days": "< 3 days",
  "4-7 days": "4-7 days",
  "8-21 days": "8-21 days",
  "> 21 days": "> 21 days"
});
export const ageProfileStackLabels = Object.freeze({
  New: "New",
  InProgress: "InProgress"
});

export const TicketAgeFilter = Object.freeze({
  less_3: "< 3 days",
  between_4_7: "4-7 days",
  between_8_21: "8-21 days",
  more_21: "> 21 days"
});

export const ageProfileStackLabelsColors = Object.freeze({
  New: "#2876A7",
  InProgress: "#83C6EC"
});

// Where a job is: My Jobs stage buttons, the dashboard In Progress chart, the
// export and the ticket details label. Mirrors enums.JobStage in fixify-server.
export const JobStage = Object.freeze({
  New: "New",
  Validate: "Validate",
  Quotes: "Quotes",
  Assigned: "Assigned",
  Booked: "Booked",
  Review: "Review",
  Completed: "Completed",
  Closed: "Closed",
  // Tradesperson only: their quote requests that are Inactive - the Filters
  // panel's "Inactive quotes", not a stage button.
  InactiveQuotes: "Inactive Quotes"
});

export const inProgressLabelSortOrder = Object.freeze({
  [JobStage.Completed]: 5,
  [JobStage.Review]: 4,
  [JobStage.Booked]: 3,
  [JobStage.Assigned]: 2,
  [JobStage.Validate]: 1
});
export const inProgressLabelSortOrderTradesperson = Object.freeze({
  [JobStage.Booked]: 1,
  [JobStage.Review]: 2
});

export const inProgressLabelColors = Object.freeze({
  [JobStage.Validate]: "#034671",
  [JobStage.Assigned]: "#2876A7",
  [JobStage.Booked]: "#479ACE",
  [JobStage.Review]: "#9CD0EE",
  [JobStage.Completed]: "#D2EFFF"
});
export const inProgressLabelTextColorColors = Object.freeze({
  [JobStage.Validate]: "white",
  [JobStage.Assigned]: "white",
  [JobStage.Booked]: "white",
  [JobStage.Review]: "black",
  [JobStage.Completed]: "black"
});

export const inProgressLabelColorsTradesperson = Object.freeze({
  [JobStage.Booked]: "#034671",
  [JobStage.Review]: "#479ACE"
});

export const AllTicketFilters = Object.freeze({
  status: "status",
  property: "property",
  tradesPerson: "tradesPerson",
  landlord: "landlord"
});

export const LandlordDispalyRoleOption = Object.freeze({
  Landlord: "Landlord",
  Property_Manager: "Property Manager",
  Letting_Agent: "Letting Agent"
});

export const TradespersonAccessLevel = Object.freeze({
  Assigned: "assigned",
  Quoted: "quoted",
  None: "none"
});

// My Jobs row quote status. Mirrors enums.MyJobsQuoteStatus in fixify-server.
export const MyJobsQuoteStatus = Object.freeze({
  Approved: "approved",
  Active: "active",
  Inactive: "inactive"
});

export const QuoteStatus = Object.freeze({
  Pending: "pending",
  Quoted: "quoted",
  Approved: "approved",
  Declined: "declined",
  Ignored: "ignored",
  Expired: "expired",
  Assigned: "assigned",
  Cancel: "cancel",
  SentToOwner: "sentToOwner",
  DeclinedByOwner: "declinedByOwner",
  ApprovedByOwner: "approvedByOwner"
});
